import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LanguageSwitcher } from "../LanguageSwitcher";
import { useTranslation } from "react-i18next";

export const Header: React.FC = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isBlogPage = location.pathname.startsWith('/blog');
  
  // 获取当前语言作为链接前缀
  const currentLang = i18n.language;
  const homeLink = currentLang === 'en' ? '/' : `/${currentLang}/`;
  
  return (
    <header className="bg-white shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to={homeLink} className="flex items-center flex-shrink-0">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo.svg" 
                alt={t('app.shortTitle')} 
                className="w-10 h-10"
              />
              <div className="flex flex-col">
                <span className="text-xl font-bold text-primary-dark">
                 Secure Anonymous TempMail 
                </span>
              </div>
            </div>
          </Link>

          <div className="flex items-center space-x-2 sm:space-x-4">
            {!isBlogPage && <LanguageSwitcher className="text-xs sm:text-base" />}
          </div>
        </div>
      </div>
    </header>
  );
};
